import axios from 'axios';

import { stringify } from '@lib/route/queryParams';

export const client = axios.create({
  baseURL: 'https://customtypes.prismic.io',
  paramsSerializer: (params) => stringify(params),
});
